import { createStore } from 'stimulus-store';

// TODO: MOVE THIS TO app/javascript/stores/deployment_statuses
export const deploymentStatusStore = createStore({
    name: 'deploymentStatusStore',
    type: Object,
    initialValue: {}
});